export const branches = (branch) => {
    return branch === 'ALL' ? '' : branch.toUpperCase();
}